import { render, staticRenderFns } from "./typicalProblemList.vue?vue&type=template&id=72bab83e&scoped=true"
import script from "./typicalProblemList.vue?vue&type=script&lang=js"
export * from "./typicalProblemList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./typicalProblemList.vue?vue&type=style&index=1&id=72bab83e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bab83e",
  null
  
)

export default component.exports